import SimpleCard from "lib/components/common/simple-card";
import SimpleDataTable from "lib/components/common/simple-data-table";
import DashboardLayout from "lib/components/layouts/dashboard";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import {
  PRACTITIONER_EXPENSES_COLUMNS,
  PRACTITIONER_INCOME_COLUMNS,
} from "lib/constants/table-columns";
import { AppContext } from "lib/contexts/app-context";

import usePractitioner from "lib/hooks/usePractitioner";
import { formatCurrency } from "lib/utils/util";
import { FC, useContext, useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";

const breadcrumbItems: BreadcrumbItem[] = [
  {
    label: "Payments",
    path: PAGE_ROUTES.PRACTITIONER.Payments,
  },
];

interface PractitionerPaymentsPageProps { }

const PractitionerPaymentsPage: FC<PractitionerPaymentsPageProps> = () => {
  const { appState } = useContext(AppContext);
  const { getPractitionerSubscriptions, loading, error, getBookingsDetails } =
    usePractitioner();

  const [subscriptions, setSubscriptions] = useState<
    PractitionerSubscriptionDetails[]
  >([]);

  const [bookingDetails, setBookingDetails] = useState<
    PatientAppointmentBookingDetails[]
  >([]);

  useEffect(() => {
    getPractitionerSubscriptions(appState?.user_id, setSubscriptions);
    getBookingsDetails(appState?.user_id, setBookingDetails);
  }, []);

  const paidAppointmentBookings = bookingDetails.filter(
    (booking) => booking.status !== "pending"
  );

  const paidSubscriptions = subscriptions.filter(
    (subscription) => subscription.isActive === true
  );

  const subscriptionsTotal = useMemo(() => {
    return (
      paidSubscriptions?.reduce(
        (total, subscription) => total + subscription.totalCost,
        0
      ) || 0
    );
  }, [paidSubscriptions]);

  const patientsTotal = useMemo(() => {
    return (
      paidAppointmentBookings?.reduce(
        (total, booking) => total + Number(booking.totalCost),
        0
      ) || 0
    );
  }, [paidAppointmentBookings]);

  return (
    <DashboardLayout breadcrumbItems={breadcrumbItems}>
      <Row>
        <Col xs={6}>
          <SimpleCard
            title="Income"
            isLoading={loading}
            error={error}
            subtitle="Patient Payments"
            action={<h4>{formatCurrency(patientsTotal ?? 0)}</h4>}
          >
            <SimpleDataTable
              columns={PRACTITIONER_INCOME_COLUMNS}
              data={paidAppointmentBookings ?? []}
            />
          </SimpleCard>
        </Col>
        <Col xs={6}>
          <SimpleCard title="Expenses" subtitle="Subscription Payments" isLoading={loading} error={error} action={<h4>{formatCurrency(subscriptionsTotal ?? 0)}</h4>}>
            <SimpleDataTable
              columns={PRACTITIONER_EXPENSES_COLUMNS}
              data={paidSubscriptions ?? []}
            />
          </SimpleCard>
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default PractitionerPaymentsPage;
